import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
export function Guarantee() {
  useTrackSection('guarantee', 'Guarantee Section');
  return <section id="guarantee" className="w-full px-4 sm:px-6 lg:px-8 py-6 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(248,250,252) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-142">
      <div className="mx-auto max-w-2xl" data-id="element-143">
        <div className="bg-white rounded-xl px-5 py-4 text-center shadow-sm" style={{
        border: '1px solid rgba(34,197,94,0.20)'
      }} data-id="element-144">
          <p className="text-sm font-black text-green-700 m-0 mb-1" data-id="element-145">
            🛡️ Garantía de 7 días
          </p>

          <p className="text-xs text-gray-600 m-0" data-id="element-146">
            Revisá todo el material con tranquilidad. Si sentís que no era lo
            que buscabas, te devolvemos el 100% de tu dinero.
          </p>
        </div>
      </div>
    </section>;
}